export const globals = {
    userName: null,
    token: null,
    //  LOCALHOST: window.location.origin,
    //REMOTEHOST: "https://" + window.location.hostname + ":8443"

    LOCALHOST: "https://lawshelf.com",
    REMOTEHOST: "https://www.lawshelf.com:8443",
    // LOCALHOST: "http://localhost:4200",
    //REMOTEHOST: "http://localhost:64320"
    //    LOCALHOST: "http://10.0.0.87",
    //    REMOTEHOST: "http://10.0.0.87:8080"
}